import React from 'react';
import {
    HierarchyGroupsConfig,
    HierarchyGroupsConfigBase,
} from '../../HierarchyGroups/Config/SectorsConfig';

export interface AreasConfig {
    readonly hideParent: boolean;
    readonly parentModelCode: string;
    readonly modelCode: string;
}

export const DefaultAreasConfig: HierarchyGroupsConfig = {
    hideParent: true,
    parentModelCode: 'COUNTRY',
    modelCode: 'AREA',

    i18nKey: '',
    createUrl: '',
    listUrl: '',
    editUrl: (id: string) => '',
};

export const AreasContext = React.createContext<HierarchyGroupsConfigBase>(DefaultAreasConfig);
export const useAreasConfig = (): HierarchyGroupsConfigBase =>
    React.useContext<HierarchyGroupsConfigBase>(AreasContext);
